module.exports = __webpack_public_path__ + "img/nraef-logo.4f2a055d.jpg";